import React, { Component } from 'react'
import { connect } from 'react-redux'
import urlFor, { QueryParams } from 'shared/tools/url-helper'
import compose from 'lodash/fp/compose'

import errorBoundary from 'client/shared/decorators/error-boundary'

import Spacer from 'client/shared/blocks/spacer'
import Shelf from 'client/bookmate/blocks/shelf'
import List, { HeaderRank } from 'client/bookmate/blocks/list'
import Linka from 'client/shared/blocks/linka'
import MetaCounters from 'client/bookmate/blocks/meta-counters'

import { getComicbookById } from 'client/bookmate/reducers/comicbooks-reducer'
import { getShelvesByIds } from 'client/bookmate/reducers/shelves-reducer'
import { ShelfProps } from 'client/shared/types/shelf'
import { ComicbookProps } from 'client/shared/types/comicbook'
import { State } from 'shared/types/redux'

type Props = {
  shelves: ShelfProps[]
  comicbook: ComicbookProps
  type: 'default' | 'small'
  currentUserLogin: string
  query?: QueryParams
  headerRank: HeaderRank
}

class ComicbookShelvesIndexBox extends Component<Props> {
  static defaultProps = {
    type: 'default',
  }

  getListHeaderRank() {
    const { type } = this.props

    switch (type) {
      case 'small':
        return 2
      case 'default':
      default:
        return 1
    }
  }

  getSpacerSize() {
    const { type } = this.props

    switch (type) {
      case 'small':
        return 32
      case 'default':
      default:
        return 48
    }
  }

  render(): JSX.Element | null {
    const { type, shelves, comicbook, query, headerRank } = this.props

    if (shelves.length === 0) return null

    return (
      <>
        <List
          header="book.on_shelves"
          headerRank={headerRank || this.getListHeaderRank()}
          allLink={urlFor.comicbookShelves(comicbook.uuid, query)}
        >
          {shelves.slice(0, 5).map(shelf => {
            return ['small'].includes(type)
              ? this.renderPseudoShelf(shelf, shelf.uuid)
              : this.renderShelf(shelf, shelf.uuid)
          })}
        </List>
        <Spacer size={this.getSpacerSize()} />
      </>
    )
  }

  renderShelf(shelf: ShelfProps, key: string): JSX.Element {
    const { currentUserLogin, query } = this.props

    return (
      <Shelf
        query={query}
        shelf={shelf}
        kind="list"
        key={key}
        as="li"
        showPlus={shelf.creator.login !== currentUserLogin}
      />
    )
  }

  renderPseudoShelf(shelf: ShelfProps, key: string): JSX.Element {
    const pseudoShelfStyle = {
      display: 'flex',
      boxSizing: 'border-box',
      minHeight: '40px',
      padding: '8px 0',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontSize: '14px',
      lineHeight: '16px',
      borderBottom: '1px solid #e7e7e7',
      fontWeight: 'bold',
    }

    return (
      <div key={key}>
        <Linka path={urlFor.shelf(shelf.uuid, this.props.query)}>
          <span style={pseudoShelfStyle}>
            <span>{shelf.title}</span>
            {shelf.posts_count > 0 && (
              <span>
                <MetaCounters
                  counters={[{ kind: 'books', count: shelf.posts_count }]}
                />
              </span>
            )}
          </span>
        </Linka>
      </div>
    )
  }
}

const connectWrapper = connect((state: State) => ({
  shelves: getShelvesByIds(state, state.comicbook.shelves),
  comicbook: getComicbookById(state, state.comicbook.uuid),
  currentUserLogin: state.currentUser.data.login,
  query: state.app.storedQuery,
}))

const wrappers = compose(connectWrapper, errorBoundary)

export default wrappers(ComicbookShelvesIndexBox)
